// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi/kpi.less
// module id = 3641
// module chunks = 0